import { create } from "zustand";
import { Activity } from "../../components/activity/types";
import { UpdateFn, Updater } from "../../types";

interface State {
  activities: Activity[];
  activitiesFetched: boolean;
}

interface Action {
  setter: <T extends keyof State>(key: T, updater: Updater<State[T]>) => void;

  setActivities: UpdateFn<Activity[]>;
  activitiesAdd: (activity: Activity) => void;
  setActivitiesFetched: UpdateFn<boolean>;
}

const useDashboardStore = create<State & Action>((set, get) => ({
  activities: [],
  activitiesFetched: false,

  setter: <T extends keyof State>(key: T, updater: Updater<State[T]>): void => {
    if (typeof updater === "function") {
      set((state) => ({ [key]: updater(state[key]) }));
    } else {
      set({ [key]: updater });
    }
  },

  setActivities: (activities) => {
    get().setter("activities", activities);
  },

  setActivitiesFetched: (activitiesFetched) => {
    get().setter("activitiesFetched", activitiesFetched);
  },

  activitiesAdd: (activity) => {
    if (!get().activitiesFetched) return;
    get().setActivities((prev) => [activity, ...prev]);
  },
}));

export default useDashboardStore;
